export default `<p><strong>ドキュメントバージョン：</strong>V3.28 &nbsp;|&nbsp; <strong>公開日：</strong>2022年 &nbsp;|&nbsp; <strong>文書種別：</strong>製品ホワイトペーパーおよびセキュリティ評価概要</p>

<h2>1. 概要</h2>
<p>本レンディングプール（Lending Pool）は、分散型金融（DeFi）マネーマーケットプロトコル上に構築されたオンチェーン流動性貸借サービスモジュールです。オープンソースのスマートコントラクトとプログラム可能な金利モデルにより、ユーザーのデジタル資産を成熟したオンチェーン貸借市場に接続し、<strong>預金による利回り、担保付き借入、流動性の共有</strong>などの中核機能を実現します。</p>
<p>本モジュールは日常の資金配分に人的介入を必要とせず、金利、キャパシティ、利用率などの主要指標はオンチェーン市場によってリアルタイムに決定され、複数ソースのデータ集約と定期同期により透明に表示されます。</p>

<h2>2. 業界背景と製品ポジション</h2>
<p>従来の貸借は信用評価と資金仲介を中央集権的な機関に依存しています。DeFi 貸借プロトコルはスマートコントラクトで需給を自動的にマッチングし、過剰担保と清算メカニズムによりシステムの支払能力を保護します。</p>
<p>本レンディングプールモジュールの位置づけ：</p>
<ul>
  <li><strong>オンチェーンマネーマーケットゲートウェイ：</strong>複数チェーン・複数プロトコルのレンディングプールデータを集約；</li>
  <li><strong>プログラムによる利回り分配：</strong>承認残高と市場 APY に基づき、固定スケジュールで自動決済；</li>
  <li><strong>透明性と検証可能性：</strong>TVL、APY、利用率、LTV は公開オンチェーンデータに遡及可能；</li>
  <li><strong>非カストディアル設計：</strong>資産承認とオンチェーン操作はユーザーのウォレットから開始。</li>
</ul>

<h2>3. システムアーキテクチャ</h2>
<h3>3.1 アーキテクチャ概要</h3>
<ul>
  <li><strong>ユーザーインターフェース層：</strong>ウォレット接続、承認、プール閲覧、収益照会；</li>
  <li><strong>ビジネスサービス層：</strong>認証、承認管理、利回り注文生成、多言語コンテンツ；</li>
  <li><strong>データ集約層：</strong>公開 DeFi データソースから定期的に指標を同期；</li>
  <li><strong>オンチェンプロトコル層：</strong>監査済みオープンソース貸借プロトコルが入出金ロジックを実行。</li>
</ul>

<h3>3.2 主要指標</h3>
<table>
  <thead>
    <tr><th>指標</th><th>説明</th></tr>
  </thead>
  <tbody>
    <tr><td>TVL</td><td>プール内資産の USD 建て総額；市場深度を反映</td></tr>
    <tr><td>Supply APY</td><td>基本金利とプロトコル報酬による預金年利</td></tr>
    <tr><td>Borrow APY</td><td>借り手が支払う年間コスト</td></tr>
    <tr><td>利用率</td><td>借入済み資金と利用可能資金の比率</td></tr>
    <tr><td>Max LTV</td><td>清算前の最大ローン・トゥ・バリュー比率</td></tr>
    <tr><td>Supply / Borrow Cap</td><td>集中リスク管理のための資産別上限</td></tr>
    <tr><td>Available Liquidity</td><td>即時借入可能な流動性</td></tr>
  </tbody>
</table>

<h2>4. ユーザーフローと利回りメカニズム</h2>
<ol>
  <li><strong>ウォレット接続</strong>（Web3 ウォレット）；</li>
  <li><strong>資産承認</strong>（USDT、USDC 等のオンチェーン Approve）；</li>
  <li><strong>レンディングプールへの参加</strong>で利回り計算キューに登録；</li>
  <li><strong>利回り決済</strong>を承認残高と市場金利に基づき毎日実行；</li>
  <li><strong>資産照会</strong>は「マイポートフォリオ」で残高と決済履歴を確認。</li>
</ol>
<p><strong>過去の APY は将来のリターンを保証しません。</strong></p>

<h3>4.3 手数料</h3>
<h4>DeFi 稼ぎの手数料はどのように請求されますか？</h4>
<p>オンチェーン取引では、申込や収益受取などスマートコントラクトとのやり取りに gas 手数料が必要です。一部の資産については、DeFi レンディングプールおよびボールト管理者が、実際に得た利益の一定割合をパフォーマンス手数料として請求する場合があります。元本には影響しません。</p>

<h2>5. セキュリティ設計</h2>
<ul>
  <li>基盤プロトコルは監査済みオープンソースコントラクトを使用；</li>
  <li>非カストディアルアーキテクチャ；秘密鍵・シードフレーズは保存しない；</li>
  <li>必要最小限の Token Approve 権限；ウォレットでいつでも取消可能；</li>
  <li>トークン認証、HTTPS、RBAC 管理、操作監査ログ。</li>
</ul>

<h2>6. セキュリティ評価概要</h2>
<table>
  <thead>
    <tr><th>項目</th><th>結果</th><th>備考</th></tr>
  </thead>
  <tbody>
    <tr><td>スマートコントラクト依存</td><td><strong>合格</strong></td><td>公開監査済み DeFi プロトコル</td></tr>
    <tr><td>非カストディアルと鍵管理</td><td><strong>合格</strong></td><td>秘密鍵の保存なし</td></tr>
    <tr><td>API と認証</td><td><strong>合格</strong></td><td>トークン認証と HTTPS 実装済み</td></tr>
    <tr><td>データ同期と一貫性</td><td><strong>合格</strong></td><td>定期同期とスナップショット</td></tr>
    <tr><td>利回り決済ロジック</td><td><strong>合格</strong></td><td>明確なルール；監査可能な注文</td></tr>
  </tbody>
</table>

<h2>7. リスク開示</h2>
<ul>
  <li><strong>スマートコントラクトリスク：</strong>未発見の脆弱性が存在する可能性；</li>
  <li><strong>市場リスク：</strong>APY は大きく変動する可能性；</li>
  <li><strong>清算リスク：</strong>担保価格の急落で清算が発生する可能性；</li>
  <li><strong>ステーブルコイン脱ペグリスク：</strong>USDT/USDC が $1.00 から乖離する可能性；</li>
  <li><strong>規制リスク：</strong>DeFi 規制は各国で進化中。</li>
</ul>
<p><strong>本モジュールは投資助言を提供せず、固定リターンを保証しません。</strong></p>

<h2>8. 用語集</h2>
<ul>
  <li><strong>APY：</strong>年利（Annual Percentage Yield）；</li>
  <li><strong>TVL：</strong>総ロック額（Total Value Locked）；</li>
  <li><strong>LTV：</strong>ローン・トゥ・バリュー比率；</li>
  <li><strong>Approve：</strong>ERC-20 トークン承認；</li>
  <li><strong>清算（Liquidation）：</strong>担保不足時に自動売却。</li>
</ul>

<p>— 本ドキュメントは情報提供のみを目的とし、法的・財務的・投資上の助言を構成しません。オンチェーンデータはブロックエクスプローラーおよび公式プロトコルインターフェースでご確認ください。</p>`
